export default __webpack_public_path__ + "static/media/logo-synapse52x50.9c2434c9.svg";